/**
 * Utility function to build all sections array
 */
export const buildAllSections = (
  changesBySection,
  {
    publishAboutDraft,
    discardAboutDraft,
    undoAboutPublish,
    publishContactDraft,
    discardContactDraft,
    undoContactPublish,
    publishQualificationDraft,
    discardQualificationDraft,
    undoQualificationPublish,
    publishHomeDraft,
    discardHomeDraft,
    undoHomePublish,
    publishSkillsDraft,
    discardSkillsDraft,
    undoSkillsPublish,
    publishCertificatesDraft,
    discardCertificatesDraft,
    undoCertificatesPublish,
    publishProjectsDraft,
    discardProjectsDraft,
    undoProjectsPublish,
    publishDefaultThemesDraft,
    discardDefaultThemesDraft,
    undoDefaultThemesPublish,
  }
) => {
  return [
    {
      id: "about",
      label: "About",
      changes: changesBySection.about,
      publish: publishAboutDraft,
      discard: discardAboutDraft,
      undo: undoAboutPublish,
    },
    {
      id: "contact",
      label: "Contact",
      changes: changesBySection.contact,
      publish: publishContactDraft,
      discard: discardContactDraft,
      undo: undoContactPublish,
    },
    {
      id: "qualification",
      label: "Qualification",
      changes: changesBySection.qualification,
      publish: publishQualificationDraft,
      discard: discardQualificationDraft,
      undo: undoQualificationPublish,
    },
    {
      id: "home",
      label: "Home",
      changes: changesBySection.home,
      publish: publishHomeDraft,
      discard: discardHomeDraft,
      undo: undoHomePublish,
    },
    {
      id: "skills",
      label: "Skills",
      changes: changesBySection.skills,
      publish: publishSkillsDraft,
      discard: discardSkillsDraft,
      undo: undoSkillsPublish,
    },
    {
      id: "certificates",
      label: "Certificates",
      changes: changesBySection.certificates,
      publish: publishCertificatesDraft,
      discard: discardCertificatesDraft,
      undo: undoCertificatesPublish,
    },
    {
      id: "projects",
      label: "Projects",
      changes: changesBySection.projects,
      publish: publishProjectsDraft,
      discard: discardProjectsDraft,
      undo: undoProjectsPublish,
    },
    {
      id: "defaultThemes",
      label: "Default Themes",
      changes: changesBySection.defaultThemes,
      publish: publishDefaultThemesDraft,
      discard: discardDefaultThemesDraft,
      undo: undoDefaultThemesPublish,
    },
  ];
};

/**
 * Utility function to build cache info map
 */
export const buildCacheInfoMap = ({
  homeCacheInfo,
  aboutCacheInfo,
  skillsCacheInfo,
  qualificationCacheInfo,
  certificatesCacheInfo,
  projectsCacheInfo,
  contactCacheInfo,
  defaultThemesCacheInfo,
}) => {
  return {
    home: homeCacheInfo,
    about: aboutCacheInfo,
    skills: skillsCacheInfo,
    qualification: qualificationCacheInfo,
    certificates: certificatesCacheInfo,
    projects: projectsCacheInfo,
    contact: contactCacheInfo,
    defaultThemes: defaultThemesCacheInfo,
  };
};
